module.exports = __webpack_public_path__ + "img/factor_b_red.3628711a.svg";